var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('iframe',{class:[_vm.$style.embededViewerIframe],attrs:{"src":_vm.readerLaunchUrl,"frameborder":"0","allowfullscreen":"","data-embeded-hybrid-viewer":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }